<div class="container-fluid">
    <div class="row">
        <div class="col d-flex justify-content-end">
            <button type="button" class="action-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <div class="row">
        <div *ngIf="isPF()">
            <h2 class="w-auto text-center">Beneficiar persoana fizica</h2>
            <h3 class="w-auto text-center">Nume: {{beneficiar.nume + " " + beneficiar.prenume}}</h3>
        </div>

        <div *ngIf="isPJ()" class="column justify-content-center text-align-center">
            <h2 class="w-auto text-center">Beneficiar persoana juridica</h2>
            <h3 class="w-auto text-center">Companie: {{beneficiar.denumire}}</h3>
        </div>
    </div>
</div>
<div class="container">
    <div class="info-card">
        <div class="info-header p-3 d-flex flex-wrap align-items-center">
            <mat-icon>info</mat-icon>
            <span class="info-title ms-3">Info Beneficiar</span>
        </div>
        <div class="info-content" *ngIf="isPF()">
            <div class="info-row">
                <label>Nume:</label>
                <span>{{beneficiar.nume}}</span>
            </div>
            <div class="info-row">
                <label>Prenume:</label>
                <span>{{beneficiar.prenume}}</span>
            </div>
            <div class="info-row">
                <label>CNP:</label>
                <span>{{beneficiar.cnp_cui}}</span>
            </div>
            <div class="info-row">
                <label>CI Serie:</label>
                <span>{{beneficiar.ci_serie}}</span>
            </div>
            <div class="info-row">
                <label>CI Număr:</label>
                <span>{{beneficiar.ci_numar}}</span>
            </div>
            <!-- aceste campuri nu sunt introduse la inregistrarea unui beneficiar la data de 02.02.2024
            <div class="info-row">
                <label>Email:</label>
                <span>{{beneficiar.email}}</span>
            </div>
            <div class="info-row">
                <label>Telefon:</label>
                <span>{{beneficiar.telefon}}</span>
            </div> -->
            <div class="info-row">
                <label>Validare Ticket:</label>
                <span>{{beneficiar.validated_by_ticket === false? 'Nu' : "Da"}}</span>
            </div>
        </div>

        <div class="info-content" *ngIf="isPJ()">
            <div class="info-row">
                <label>Denumire companie:</label>
                <span>{{beneficiar.denumire}}</span>
            </div>
            <div class="info-row">
                <label>CUI/CIF:</label>
                <span>{{beneficiar.cnp_cui}}</span>
            </div>
            <div class="info-row">
                <label>Registrul comerțului</label>
                <span>{{beneficiar.reg_com}}</span>
            </div>
            <div class="info-row">
                <label>Validare Ticket:</label>
                <span>{{beneficiar.validated_by_ticket === false? 'Nu' : "Da"}}</span>
            </div>
        </div>

    </div>

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Close</button>
    </mat-dialog-actions>
</div>